import script from "./ModalWindow.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalWindow.vue?vue&type=script&lang=ts&setup=true"

import "./ModalWindow.vue?vue&type=style&index=0&id=6752bda4&lang=css"

const __exports__ = script;

export default __exports__